import { Component, OnInit } from '@angular/core';
import { RemedialModel } from 'src/app/models/remedial.model';
import { ClientService } from 'src/app/services/client/client.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-select-remedials',
  templateUrl: './modal-select-remedials.component.html',
  styleUrls: ['./modal-select-remedials.component.scss'],
})
export class ModalSelectRemedialsComponent implements OnInit {

  allRemedials: Array<RemedialModel>;
  chosenRemedials = new Array<RemedialModel>();


  constructor(public clientService: ClientService, public modalControllerTwo: ModalController) 
  { 

  }


  ngOnInit() {}


  ionViewWillEnter()
  {
   this.allRemedials = this.clientService.getRemedialCodes();

   for (var i = 0; i < this.allRemedials.length; i++)
   {
     this.allRemedials[i].quantity = 0;

     for (var x = 0; x < this.chosenRemedials.length; x++)
     {
       if (this.chosenRemedials[x].remedialUid == this.allRemedials[i].remedialUid)
       {
         this.allRemedials[i] = this.chosenRemedials[x];
       }
     }
   }
  }


  saveNewStlPreset()
  {        
    var returnData = { 
      chosenRemedials: this.chosenRemedials,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid()
    };

    this.modalControllerTwo.dismiss(returnData, null, 'StlPresetModal');
  }


  increaseStlQuanity(choice)
  {
    if (choice.quantity == 0)
    {
      choice.quantity = 1;
      this.chosenRemedials.push(choice);
    }
    else
    {
      for (var i = 0; i < this.chosenRemedials.length; i++)
      {
        if (this.chosenRemedials[i].remedialUid == choice.remedialUid)
        {
          this.chosenRemedials[i].quantity += 1;
          break;
        }
      }
    }
  }


  decreaseStlQuanity(choice)
  {
    if (choice.quantity > 0)
    {
      for (var i = 0; i < this.chosenRemedials.length; i++)
      {
        if (this.chosenRemedials[i].remedialUid == choice.remedialUid)
        {
          this.chosenRemedials[i].quantity--;
          break;
        }
      }
    }
  }


  closeModal(returnData = null)
  {
    this.modalControllerTwo.dismiss(returnData, null, 'StlPresetModal');
  }
}